// Maps a `tickets` row (snake_case Postgres columns; used klippekort clips are
// tickets rows too, with klippekort_id set) to the camelCase "ticket-like" shape features/tickets/roundTicket.js
// and ticketTime.js already expect (matches the old Firestore doc fields).
// ISO date strings from Postgres parse fine through those utils' existing
// Date.parse() string-handling branch, so only the keys need renaming.
export function toTicketShape(row) {
  if (!row) return null;
  return {
    id: row.id,
    name: row.name,
    category: row.category,
    type: row.type,
    ticketType: row.ticket_type,
    duration: row.duration,
    bonusMinutes: row.bonus_minutes,
    quantity: row.quantity,
    price: row.price,
    ticketNumber: row.ticket_number,
    ticketRef: row.ticket_ref || row.id,
    datePurchased: row.date_purchased,
    activatedAt: row.activated_at,
    totalDuration: row.total_duration,
    activatedFrom: row.activated_from,
    printedAt: row.printed_at,
    printedFrom: row.printed_from,
    usedAt: row.used_at,
    isPlaying: row.is_playing,
    isActive: !row.refunded,
    refunded: row.refunded,
    refundedAt: row.refunded_at,
    backupCode: row.backup_code,
    orderId: row.order_id,
    // Klippekort-specific
    usedStamps: row.used_stamps,
    klippekortId: row.klippekort_id,
  };
}

// A redeemed klippekort clip (klippekort_redemptions row). The table has no
// category/type columns, so mark it the way the ticket list expects klippekort
// clips - otherwise the clip is in the database but never shown to start.
export function toRedemptionTicketShape(row) {
  if (!row) return null;
  return { ...toTicketShape(row), category: "klippekort", type: "stampCardTicket", fromKlippekort: true };
}

// Maps a `klippekort` row (the parent stamp-card, not a redemption) to the
// camelCase shape cartPricing.js's isActiveKlippekort and KlippekortRedeem.jsx
// already expect.
export function toKlippekortCardShape(row) {
  if (!row) return null;
  return {
    id: row.id,
    name: row.name,
    duration: row.duration,
    bonusMinutes: row.bonus_minutes,
    stampAmounts: row.stamp_amounts,
    stampTotal: row.stamp_amounts,
    stampUsed: row.used_stamps,
    stampsLeft: (row.stamp_amounts || 0) - (row.used_stamps || 0),
    datePurchased: row.date_purchased,
    orderId: row.order_id,
    productId: row.product_id,
  };
}
